import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  FeatureCard,
  Stats,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import { Fragment } from "react";
import Lottie from "react-lottie";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SecurityIcon from "@mui/icons-material/Security";
import CloudIcon from "@mui/icons-material/Cloud";
import BackupIcon from "@mui/icons-material/Backup";
import ComputerIcon from "@mui/icons-material/Computer";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

export default function DigitalMarketing() {
  useEffect(() => {}, []);

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <Hero
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          title="Managed IT Services"
          subtitle={
            <div>
              <p>
                Partnering with our managed IT services ensures your business
                has a reliable, secure, and efficient IT infrastructure. Here's
                why we're the best choice:
              </p>
              {!state.auth.isMobile ? (
                <ul>
                  <li>
                    <strong>24/7 IT Support</strong>: We provide round-the-clock
                    monitoring and support, ensuring your systems are always
                    operational.
                  </li>
                  <li>
                    <strong>Proactive Network Security</strong>: We secure your
                    IT environment with the latest security measures to protect
                    your data and infrastructure from cyber threats.
                  </li>
                  <li>
                    <strong>Cloud Solutions & Data Backup</strong>: Our cloud
                    management and backup services ensure your critical business
                    data is always safe and accessible.
                  </li>
                </ul>
              ) : (
                ""
              )}
              <p>
                By choosing us, you get a dedicated team of IT professionals
                focused on optimizing your technology, enhancing your security,
                and supporting your business growth with dependable IT
                solutions.
              </p>
            </div>
          }
        />

        <ContentSideBySideInv
          title="Key benefits of Digital Marketing for Business"
          subtitle={
            <div style={{ marginLeft: "15px" }}>
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
              Increased Online Visibility
              </div>
              Digital marketing enhances your brand's presence on the internet,
               making it easier for potential customers to find and engage with your business.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                Targeted Audience Reach
              </div>
              Digital marketing allows you to reach specific audience segments with personalized messages, 
              ensuring your marketing efforts are more effective and efficient.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
                Measurable Results
              </div>
              Digital marketing provides real-time analytics and insights, allowing you to track the performance of your 
              campaigns and make data-driven decisions to optimize your strategies.
            </div>
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/marketing (5).json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        <SpacerV height={"100px"} />
        <SpacerV height={"100px"} />
        <ContentSideBySide
          title="Optimizing Your Business with Managed IT Services"
          subtitle={
            "Maximize your business efficiency with expert Managed IT Services. From proactive network monitoring to 24/7 IT support, we ensure your infrastructure runs smoothly and securely. With scalable cloud solutions, real-time threat detection, and strategic IT consulting, you can focus on growth while we handle the tech. Our AI-driven systems and automated processes optimize your workflows, reduce downtime, and protect your data. Let our IT services empower your business with cutting-edge technology and seamless performance."
          }
          image={
            <Lottie
              style={{ marginTop: "-65px", marginBottom: "50px" }}
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/marketing (10).json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        <ThreeSideBySide
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          spacing={5}
          subtitle1={
            <Fragment>
              <FeatureCard
                minHeight={"55vh"}
                title={"24/7 IT Support"}
                text={`Ensure your business stays operational with round-the-clock IT support. Our experts are always available to address issues and provide assistance, minimizing downtime and ensuring business continuity.`}
                icon={
                  <SupportAgentIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
              <br />
              <br />
              <FeatureCard
                minHeight={"55vh"}
                title={"Network Security"}
                text={`Protect your business from cyber threats with our proactive network security solutions. We implement firewall management, intrusion detection, and real-time monitoring to safeguard your infrastructure from potential attacks.`}
                icon={
                  <SecurityIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle2={
            <Fragment>
              <FeatureCard
                minHeight={"55vh"}
                title={"Cloud Solutions"}
                text={`Enhance collaboration and scalability with our secure cloud computing solutions. We provide cloud hosting, storage, and backup services to ensure your data is always accessible, secure, and reliable.`}
                icon={
                  <CloudIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
              <br />
              <br />
              <FeatureCard
                minHeight={"55vh"}
                title={"Data Backup & Recovery"}
                text={`Minimize the risk of data loss with our comprehensive backup and recovery solutions. We ensure your data is regularly backed up and recoverable in the event of a disaster, ensuring business continuity.`}
                icon={
                  <BackupIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle3={
            <Fragment>
              <FeatureCard
                minHeight={"55vh"}
                title={"Managed IT Infrastructure"}
                text={`Optimize your IT infrastructure with our managed services. We ensure your hardware, networks, and software are well-maintained, efficient, and fully supported, reducing operational costs and improving performance.`}
                icon={
                  <ComputerIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
              <br />
              <br />
              <FeatureCard
                minHeight={"55vh"}
                title={"IT Consulting"}
                text={`Leverage our expertise to guide your IT strategy. We provide consulting services to optimize your technology investments, improve system efficiencies, and support your business goals.`}
                icon={
                  <TrendingUpIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
        />

        <Stats />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
